module finadai.app.payments {
  export var NAME = 'finadai.app.payments';
  function ConfigRoutes($stateProvider: ng.ui.IStateProvider, $urlRouterProvider: ng.ui.IUrlRouterProvider) {
    $urlRouterProvider.when('/payments', '/payments/list');
    $stateProvider
      .state('app.payments', {
        template: '<div ui-view></div>',
        url: '/payments',
      })
      .state('app.payments.list', {
        templateUrl: 'app/payments/list/list.tpl.html',
        controller: 'PaymentsListController',
        controllerAs: 'vm',
        url: '/list'
      });
  }
  export function run() {
    var payments = angular.module(NAME, [
      finadai.app.payments.list.NAME
    ]);
    payments.config(ConfigRoutes);
  }
} finadai.app.payments.run();